export const SUBSCRIPTION_PLAN_BANNER_TEXTS = {
  reactivateAccount: "Reativar Assinatura",
  messages: {
    payment_not_confirmed:
      "Seu acesso será liberado assim que o pagamento for confirmado",
    plan_expired:
      "Seu plano expirou. Renove sua assinatura para continuar utilizando a plataforma.",
    canceled_but_active: (date: string) =>
      `Você cancelou sua assinatura, mas ainda pode aproveitar todos os recursos até ${date}`,
  },
} as const;

export const REGULARIZATION_PERIOD_CREDITS_BANNER_TEXTS = {
  message:
    "Não conseguimos confirmar seu pagamento. Regularize sua assinatura para evitar interrupção dos seus benefícios.",
  cta: "Regularizar",
} as const;
